import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfigurationService, DashboardContext, DashboardDialogService, DialogService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { DashboardDialogRegistry } from '@sdbn/appclient';
import { DashboardDialogComponent } from '@sdbn/appclient';
import { TransportRepresentation } from 'src/tmc-yard/common/model/transport.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-transport-details-dialog-action',
  templateUrl: './transport-details-dialog-action.component.html',
  styleUrls: ['./transport-details-dialog-action.component.scss']
})
export class TransportDetailsDialogActionComponent {

  @Input() disabled = false;

  @Input() transport: TransportRepresentation;

  @Input() asButton = false;

  @Input() dashboardContext: DashboardContext;

  private dashboardDialogRegistry = new DashboardDialogRegistry();

  @Output() onChange = new EventEmitter<void>();

  contextSubscription: Subscription;

  constructor(
    public translationService: TranslationService,
    private dialogService: DialogService,
    private configurationService: ConfigurationService,
    private dashboardDialogService: DashboardDialogService
  ) { }

  clickButton() {

    const dashboardContext = this.dashboardContext == null ? new DashboardContext() : this.dashboardContext;
    dashboardContext.setContextValue('selected-transport', this.transport);
    this.dashboardDialogService.openTransportDetailsDialog(dashboardContext);

  }
}

